<template>
  <div
    v-if="item"
    :id="screen.chave"
    :data-screen-id="identify ? screen.id : null"
    :data-record-id="itemId(item)"
    :class="[
      'approved-heading',
      { 'section-heading': spaced, centered: centered, 'is-highlighted': highlighted },
    ]"
  >
    <p v-if="text(layout.eyebrow)" class="eyebrow">{{ text(layout.eyebrow) }}</p>
    <component :is="tag" v-if="text(layout.heading)" :data-field="layout.heading">{{
      text(layout.heading)
    }}</component>
    <RichText
      v-for="field in bodyFields"
      :key="field"
      :value="value(field)"
      :data-field="field"
      :data-campo="field.replace('iti_descricao', 'itiDescricao')"
      class="prose"
    />
  </div>
</template>
<script>
import RichText from './RichText.vue';
import { contentValue, plainText, itemId, boolValue } from '@/services/contentApi';
export default {
  name: 'ApprovedHeading',
  components: { RichText },
  props: {
    item: Object,
    screen: Object,
    layout: { type: Object, required: true },
    tag: { type: String, default: 'h2' },
    centered: Boolean,
    spaced: Boolean,
    identify: { type: Boolean, default: true },
  },
  computed: {
    bodyFields() {
      return (this.layout.body || []).filter((f) => this.value(f));
    },
    highlighted() {
      return (
        this.screen.campos.some((f) => f.campo === 'iti_destaque') &&
        boolValue(contentValue(this.item, 'iti_destaque'), false)
      );
    },
  },
  methods: {
    itemId,
    value(field) {
      return field && this.screen.campos.some((f) => f.campo === field)
        ? contentValue(this.item, field)
        : '';
    },
    text(field) {
      return plainText(this.value(field));
    },
  },
};
</script>
